import { FORECAST_MODELS } from '../../common/static-data/models';
import { BufferedFrameCache, readyForPlayback } from './caching';

/**
 * Finds the closest past loaded frame from the current frame position
 */
export function findClosestPastLoadedFrame(
  currentFrame: number | null,
  frameCache: BufferedFrameCache | null,
): number | null {
  if (frameCache == null || currentFrame === null) return null;

  // If current frame is ready for playback (loaded or interpolable), return it
  if (readyForPlayback(frameCache.frames[currentFrame])) {
    return currentFrame;
  }

  // Look backwards from current frame to find the closest loaded frame
  for (let i = currentFrame - 1; i >= 0; i--) {
    if (readyForPlayback(frameCache.frames[i])) {
      return i;
    }
  }

  return null;
}

/**
 * Helper function to get model display information
 */
export function getModelInfo(modelId: string) {
  const model = FORECAST_MODELS.find((m) => m.id === modelId);
  return {
    label: model?.label || modelId.toUpperCase(),
    description: model?.description || `Weather model: ${modelId}`,
    provider: model?.provider || 'unknown',
  };
}
